import React from 'react';
import { Handle, Position } from '@xyflow/react';

export const Node = ({ id, data }) => {

  console.log("!!! NODE DATA: ", data);
  return (
    <div style={{ display: "flex", flexDirection: "column", padding: "10px", border: "1px solid var(--main-border-color)", borderRadius: "8px", backgroundColor: "var(--content-item-bg)" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <p>Oscillator Node</p>

        <label>
          <span>Frequency</span>
          <input
            className="nodrag"
            type="range"
            min="10"
            max="1000"
            value={data.frequency} />
          <span>{data.frequency}Hz</span>
        </label>

        <label>
          <span>Waveform</span>
        </label>
        <select className="nodrag" value={data.type}>
          <option value="sine">sine</option>
          <option value="triangle">triangle</option>
          <option value="sawtooth">sawtooth</option>
          <option value="square">square</option>
        </select>
      </div>
      <Handle type="target" position={Position.Left} style={{ height: "12px", width: "12px" }} />
      <Handle type="source" position={Position.Right} style={{ top: "20%", height: "12px", width: "12px" }} id="a" />
      <Handle type="source" position={Position.Right} style={{ top: "80%", height: "12px", width: "12px" }} id="b" />
    </div>
  );
};

export default Node;
